import { Box, Step, StepLabel, Stepper } from "@mui/material";
import { FC } from "react";

type PaymentStepperProps = {
    currentStep: number,
}

const PaymentStepper: FC<PaymentStepperProps> = ({ currentStep }) => {


    const steps = ['Se över din order', 'Betala', 'Ladda hem dina bilder'];


    return (
        <Box sx={{ width: '100%', marginBottom: '1rem' }}>
            <Stepper activeStep={currentStep}>
                {steps.map((label, index) => {
                    const stepProps: { completed?: boolean } = {};
                    // if (isStepOptional(index)) {
                    //     labelProps.optional = (
                    //         <Typography variant="caption">Optional</Typography>
                    //     );
                    // }
                    // if (isStepSkipped(index)) {
                    //     stepProps.completed = false;
                    // }
                    if (index < currentStep) {
                        stepProps.completed = true;
                    }
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
        </Box>
    );
    // }
};

export { PaymentStepper };
